import React from 'react';
import { Col } from "react-bootstrap"
import "./SecondRow.css"

import { useGlobalState } from '../../../config/routes';

import GO from '../../../assets/GO/Grand Opening 2.0 (Personal).png'

const RightLowerPanel = () => {

    const {isBusinessVisible} = useGlobalState();


    return (
        <Col className={(isBusinessVisible ? " " : "") +'col-12 col-sm-4 thirdThird_container'}>
                    <h1>Testimonials / Events</h1>
                    
                    <div className="card border border-danger rounded my-2 edu_card" style={{ backgroundColor: "transparent", color: "white" }}>
                    <div className="row no-gutters">
                        <div className="col-sm-4 d-flex first_education">
                            <a href="https://www.senecacollege.ca/home.html" target="blank" >
                                <img src="https://www.amway.ca/medias/126807V-en-CA-690px-03?context=bWFzdGVyfGltYWdlc3wyMjU4MDh8aW1hZ2UvcG5nfHN5cy1tYXN0ZXIvaW1hZ2VzL2hhYS9oOGQvOTY0Mzk0NjU3Mzg1NC8xMjY4MDdWLWVuLUNBLTY5MHB4LTAzfGQwZWRhNzY3OWQxOWExZTkyMWE1ODMwODM0ZGEwOTc0NzRhZjY3MWU3MjMzNDc0MDVlYzRkMmNhODZiZDYwY2E" 
                                className="card-img" alt="Seneca College" />
                            </a>
                        </div>
                        <div className="col-sm-8">
                            <div className="card-body p-0 ">
                                <h5 className="card-title my-0">Grand Opening</h5>
                                <p className="card-text my-0">Video</p>
                                <p className="card-text">2025</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card border border-light rounded my-2 edu_card" style={{ backgroundColor: "transparent", color: "white" }}>
                    <div className="row no-gutters">
                        <div className="col-sm-4 d-flex second_education">
                            <a href="https://www.ucaldas.edu.co/portal/" target="blank">
                                <img src="https://www.amway.ca/medias/128154C-en-CA-690px-02?context=bWFzdGVyfGltYWdlc3w2MjI3Njl8aW1hZ2UvcG5nfHN5cy1tYXN0ZXIvaW1hZ2VzL2g4Mi9oNTYvMTAwOTc4MTE0MjMyNjIvMTI4MTU0Qy1lbi1DQS02OTBweC0wMnwxOTc5NjI4OTkwYWU4ZjFjOGM2MzcwOWJjOGU1ZDUzNTJjZTUzMzFhZTFhYmYzMzk1YzY4MjNmMjUzNjYyOGZk"
                                className="card-img" alt="University of Caldas" />
                            </a>
                        </div>
                        <div className="col-sm-8">
                            <div className="card-body p-0 ">
                                <h5 className="card-title my-0">Client testimonials</h5>
                                <p className="card-text my-0">Consultations</p>
                                <p className="card-text">2025</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card border border-success rounded my-2 edu_card" style={{ backgroundColor: "transparent", color: "white" }}>
                    <div className="row no-gutters">
                        <div className="col-sm-4 d-flex third_education">
                            <a href="https://www.sena.edu.co/es-co/Paginas/default.aspx" target="blank">
                                <img src="https://www.amway.ca/medias/bty-00-Brands-Artistry-m.jpg?context=bWFzdGVyfHJvb3R8NTAzMjY3fGltYWdlL2pwZWd8c3lzLW1hc3Rlci9yb290L2g4Ny9oNDcvOTUyODY5MTk4MjM2Ni9idHktMDAtQnJhbmRzLUFydGlzdHJ5LW0uanBnfDE4OTM3Yzk1YjQ2ZjUwOGI0MDQ4YTQ1MDJkYzA3ZGE4Y2QyMGNlYTU1NGEzYThjODNkNDA1NzhiYTJjMDQ4OTE" 
                                className="card-img" alt="SENA" />
                            </a>
                        </div>
                        <div className="col-sm-8">
                            <div className="card-body p-0 ">
                                <h5 className="card-title my-0">Client testimonials</h5>
                                <p className="card-text my-0">Consultations</p>
                                <p className="card-text">2025</p>
                            </div>
                        </div>
                    </div>
                </div>
                <p className='text-center'><b>(IN CONSTRUCTION)</b></p>
        </Col>

    );
};

export default RightLowerPanel;
